export function SecondaryAccountIsInactive() {
	return <p>
		Sorry. This secondary account is inactive. Please reach out to
		<a href='mailto:support@esgisoftware.com'>support@esgisoftware.com</a> if you have any questions.
	</p>
}